<template>
	<div class="video-config">
		<el-dialog :visible.sync="centerDialogVisible" width="385px" center v-if="centerDialogVisible"
			custom-class="dialog" :before-close="cancelVisible" :close-on-click-modal="false">
			<!-- <div class="" slot="title"
				style="text-align: left;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;">
				{{isConfigEdit ? '编辑线路' : '添加线路'}}
			</div> -->
			<!-- {{configForm}} -->
			<el-form :model="configForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm"
				:rules="rules" label-position="left">
				<el-form-item label="线路名">
					<template v-if="configForm.type == 'TESTING'"> 画面1-会议测试中</template>
					<template v-if="configForm.type == 'START_LATER'">画面2-会议稍后开始 </template>
					<template v-if="configForm.type == 'ONGOING'"> 画面3-直播画面</template>
					<template v-if="configForm.type == 'VOTING'">画面4-投票表决中 </template>
					<template v-if="configForm.type == 'ENDED'"> 画面5-会议已结束</template>
					<template v-if="configForm.type == 'VOD'">画面6-直播回放 </template>
					<!-- <template>{{ isConfigEdit ? configForm.name : name }}</template> -->
				</el-form-item>
				<el-form-item label="会议直播" prop="pushDomainName">
					<el-select style="width: 100%;" v-model="configForm.pushDomainName" placeholder="请选择域名"
						:disabled="(meetingInfo.state === 'ONGOING' || meetingInfo.state === 'TESTING') && isConfigEdit">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="画面显示" prop="type">
					<el-select style="width: 100%;" v-model="configForm.type" placeholder="请选择">
						<el-option label="画面1-会议测试中" value="TESTING"> </el-option>
						<el-option label="画面2-会议稍后开始" value="START_LATER"> </el-option>
						<el-option label="画面3-直播画面" value="ONGOING"> </el-option>
						<el-option label="画面4-投票表决中" value="VOTING"> </el-option>
						<el-option label="画面5-会议已结束" value="ENDED"> </el-option>
						<el-option label="画面6-直播回放" value="VOD"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="configForm.type == 'VOD'" label="视频地址" prop="flvPullUrl">
					<el-input style="width: 100%;" v-model="configForm.flvPullUrl" placeholder="请输入视频地址"></el-input>
				</el-form-item>
				<!-- <el-form-item label="AppName" prop="appName">
                    <el-input
                        v-model.trim="configForm.appName"
                        placeholder="请输入AppName, 注意不能有空格"
                        :disabled="(meetingInfo.state === 'ONGOING' || meetingInfo.state === 'TESTING') && isConfigEdit"
                    ></el-input>
                    <el-button type="text" v-if="!isConfigEdit">(若不输入任何内容，由系统随机产生分配)</el-button>
                </el-form-item>
                <el-form-item label="流的名称" prop="streamName">
                    <el-input
                        v-model.trim="configForm.streamName"
                        placeholder="请输入流的名称, 注意不能有空格"
                        :disabled="(meetingInfo.state === 'ONGOING' || meetingInfo.state === 'TESTING') && isConfigEdit"
                    ></el-input>
                    <el-button type="text" v-if="!isConfigEdit">(若不输入任何内容，由系统随机产生分配)</el-button>
                </el-form-item> -->
				<el-form-item label="视频字幕" prop="liveName">
					<el-input style="width: 100%;" v-model="configForm.liveName" placeholder="请输入视频字幕"></el-input>
					<el-button type="text" v-if="!isConfigEdit">(请输入视频字幕)</el-button>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<!-- type="primary" -->
				<el-button style="width: 120px;" @click="cancelVisible" plain>取消</el-button>
				<!-- style="background:#de4d2a !important" -->
				<el-button style="width: 120px;" type="primary" @click="updateConfig" :loading="loading">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addLiveLine,
		editLineInfo,
		editLineWholeInfo
	} from '@/serve/live';
	export default {
		components: {},
		props: {
			meetingInfo: Object,
			centerDialogVisible: Boolean,
			domainList: Array,
			config: Array,
			configForm: Object,
			meetingId: String,
			isConfigEdit: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			options() {
				let arr = [];
				this.domainList.forEach(item => {
					arr.push({
						label: item.domainName,
						value: item.id
					});
				});
				return arr;
			},
			// 线路名
			name() {
				return '线路' + (this.config.length + 1);
			}
		},
		data() {
			return {
				loading: false,
				rules: {
					pushDomainName: [{
						required: true,
						message: '请选择域名',
						trigger: 'blur'
					}],
					serverAddress: [{
						required: true,
						message: '请输入流的服务器地址',
						trigger: 'blur'
					}],
					videoSubtitles: [{
						required: true,
						message: '请输入流的名次',
						trigger: 'blur'
					}],
					liveName: [{
						required: true,
						message: '请输入视频字幕',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择画面显示',
						trigger: 'blur'
					}],
					flvPullUrl: [{
						required: true,
						message: '请输入视频地址',
						trigger: 'blur'
					}]
				}
			};
		},
		created() {
			console.log("meetingInfo", this.meetingInfo)
		},
		methods: {
			cancelVisible() {
				let bool = !!this.config.length;
				this.$emit('reset');
				this.$emit('cancel', 'centerDialogVisible');
				if (!bool) {
					this.$emit('defaultSet');
				} else {
					this.$emit('refresh', this.meetingId);
				}
			},
			// 查询当前域名id
			searchDomainId(obj) {
				if (Number.isFinite(Number(this.configForm.pushDomainName))) {
					obj.pushDomainId = this.configForm.pushDomainName;
				} else {
					const arr = this.options.filter(item => item.label === this.configForm.pushDomainName);
					obj.pushDomainId = arr[0].value;
				}
			},
			// 更新配置
			updateConfig() {

				console.log("configForm", this.meetingInfo)
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						// 编辑/添加
						this.loading = true;
						let name = '';
						if(this.configForm.type == 'TESTING'){
							name = '画面1-会议测试中';
						}else if(this.configForm.type == 'START_LATER'){
							name = '画面2-会议稍后开始';
						}else if(this.configForm.type == 'ONGOING'){
							name = '画面3-直播画面';
						}else if(this.configForm.type == 'VOTING'){
							name = '画面4-投票表决中';
						}else if(this.configForm.type == 'ENDED'){
							name = '画面5-会议已结束';
						}else if(this.configForm.type == 'VOD'){
							name = '画面6-直播回放';
						}
						if (this.isConfigEdit) {
							this.$confirm('确认当前修改?', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									customClass: 'del-model',
									type: 'warning'
								})
								.then(() => {
									console.log("configForm", this.meetingInfo)
									console.log("this.meetingInfo", this.meetingInfo)
									console.log("编辑")
									if (this.meetingInfo.state === 'ONGOING' || this.meetingInfo.state ===
										'TESTING' || this
										.meetingInfo.state === 'ENDED') {
										editLineInfo(this.meetingId, this.configForm.id, {
												name: name,
												liveName: this.configForm.liveName,
												url: this.configForm.flvPullUrl
											})
											.then(() => {
												this.loading = false;
												this.$message.success('编辑成功');
												this.cancelVisible();
											})
											.catch(err => {
												this.loading = false;
												this.$message.error(err.data.message);
											});
									} else {
										console.log("添加")
										let arr = this.options.filter(item => item.label === this.configForm
											.pushDomainName);
										this.configForm.pushDomainId = arr[0].value;
										this.configForm.url = this.configForm.flvPullUrl;
										editLineWholeInfo(this.meetingId, this.configForm.id, this.configForm)
											.then(() => {
												this.loading = false;
												this.$message.success('编辑成功');
												this.cancelVisible();
											})
											.catch(err => {
												this.loading = false;
												this.$message.error(err.data.message);
											});
									}
								})
								.catch(() => {
									this.loading = false;
								});
						} else {
							let configForm = {
								...this.configForm
							};
							configForm.url = this.configForm.flvPullUrl;
							configForm.name = name;
							this.searchDomainId(configForm);
							addLiveLine(this.meetingId, configForm)
								.then(res => {
									this.loading = false;
									this.$message.success('添加成功');
									this.cancelVisible();
								})
								.catch(err => {
									this.loading = false;
									this.$message.error(err.data.message);
								});
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			}
		}
	};
</script>
<style scoped lang="scss">
	// ::v-deep .el-dialog--center .el-dialog__body {
	// 	padding: 0px;
	// }
</style>